import { h, Fragment, cn } from '../../../lib/vdom.js';
import IconCardGrid, { IconCard } from './IconCardGrid.jsx';
import * as I from './Icon.jsx';

export default function Services() {
  return (
    <section id="services">
      <div className="content">
        <h3 className="section-subheading">OUR SERVICES</h3>
        <h1 className="section-heading">How Can We Help You?</h1>
        <IconCardGrid blue>
          <IconCard heading="Consultation & Brainstorming" icon={<I.IconComments />}>
            <IconCard.Desc>
              Collaborate with seasoned professionals to refine project ideas and create robust, scalable SaaS
              applications tailored to your business needs.
            </IconCard.Desc>
          </IconCard>
          <IconCard heading="Custom Web Development & UX/UI" icon={<I.IconCode />}>
            <IconCard.Desc>
              Develop complex, robust web applications tailored to your unique requirements.
            </IconCard.Desc>
          </IconCard>
          <IconCard heading="Enterprise Automation" icon={<I.IconLightning />}>
            <IconCard.Desc>
              Streamline your enterprise operations with cutting-edge automation technologies, from custom workflows to
              integrated systems, enhancing productivity and reducing manual tasks.
            </IconCard.Desc>
          </IconCard>
          <IconCard heading="Legacy Software Modernization" icon={<I.IconRecycle />}>
            <IconCard.Desc>
              Revitalize outdated software and develop custom solutions like CMS and CRM to automate and enhance
              business operations.
            </IconCard.Desc>
          </IconCard>
          <IconCard heading="Hosting & Managed Cloud" icon={<I.IconCloud />}>
            <IconCard.Desc>
              Ensure smooth and efficient deployment of your applications, with expert-managed cloud services to
              guarantee performance, scalability, and security.
            </IconCard.Desc>
          </IconCard>
          <IconCard heading="Long-Term Support" icon={<I.IconShield />}>
            <IconCard.Desc>
              Maintain high-quality standards, safeguard your data, and benefit from dedicated long-term support to keep
              your systems running smoothly.
            </IconCard.Desc>
          </IconCard>
        </IconCardGrid>
        {/*
          <p>Schedule a consultation to discuss your needs and brainstorm solutions we can build for you.</p>
          <div className="button-container">
            <a className="book-button" href={getBookHref()}>
              SCHEDULE CONSULTATION
            </a>
          </div>
          */}
      </div>
    </section>
  );
}
